import { doc, updateDoc, getDoc } from 'firebase/firestore';
import { db, collections } from '@/lib/firebase';
import { getEvaluatorsForUser } from './query';

export async function checkAndAutoFinalizeEvaluators(userId: string): Promise<void> {
  try {
    const userRef = doc(db, collections.users, userId);
    const userDoc = await getDoc(userRef);
    
    if (!userDoc.exists()) return;

    const userData = userDoc.data();
    const evaluators = await getEvaluatorsForUser(userId);

    // Get plan details
    const planRef = doc(db, collections.plans, userData.selectedPlanId);
    const planDoc = await getDoc(planRef);
    
    if (!planDoc.exists()) return;

    const plan = planDoc.data();
    if (plan.maxEvaluators > 5) return;

    // Check completion conditions
    const allCompleted = evaluators.every(e => e.evaluationCompleted);
    const allContextualized = evaluators.every(e => e.contextualized);

    if (allCompleted && allContextualized) {
      await updateDoc(userRef, {
        evaluatorsFinalized: true,
        updatedAt: new Date()
      });
    }
  } catch (error) {
    console.error('Error in auto-finalize check:', error);
  }
}